import { Menu } from 'antd';
import styled, { css } from 'styled-components';
import { SearchInput } from 'components/SearchInput/SearchInput';
import { DisplayModeType, effect } from 'styles';

export const SearchContainer = styled.div`
  position: relative;
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 100px;
  user-select: none;
`;

export const SearchMenu = styled(Menu)`
  position: absolute;
  top: 100%;
  left: 21px;
  right: 21px;
  z-index: 1;
  background-color: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.grey90};
  margin: 0;
`;

export const SItem = styled(Menu.Item)`
  padding: 12px 12px;
  ${effect.hover.colorBrand}
  ${effect.focus.colorBrand}
`;

const bgCss = css<{ displayMode: DisplayModeType }>`
  background-color: ${({ theme, displayMode }) => theme.displayMode[displayMode].searchBackgroundColor};
`;

export const SSearchInput = styled(SearchInput)<{ displayMode: DisplayModeType }>`
  ${bgCss};

  .ant-input {
    color: ${({ theme, displayMode }) => theme.displayMode[displayMode].searchFontColor};
    caret-color: ${({ theme, displayMode }) => theme.displayMode[displayMode].searchFontColor};
  }

  .ant-input-group-addon {
    ${bgCss};
    border: none;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px ${({ theme, displayMode }) => theme.displayMode[displayMode].searchBackgroundColor}
      inset !important;
    -webkit-text-fill-color: ${({ theme, displayMode }) => theme.displayMode[displayMode].searchFontColor} !important;
    caret-color: ${({ theme, displayMode }) => theme.displayMode[displayMode].searchFontColor} !important;
    transition: background-color 5000s ease-in-out 0s;
  }
`;
